<div class="llm-panel">
  <div class="llm-panel__head">
    <div>
      <h3 class="llm-panel__title">{{ 'Eigene KI-Zugangsdaten' | translate }}</h3>
      <div class="llm-panel__hint">
        {{ 'Mit eigenen Zugangsdaten rechnen Sie direkt beim Anbieter ab und nicht über nextPIM' | translate }}
      </div>
    </div>
    <dx-button
      *ngIf="isManager"
      stylingMode="contained"
      type="default"
      icon="plus"
      text="{{ 'Zugang hinzufügen' | translate }}"
      (onClick)="onAdd()"
    ></dx-button>
  </div>

  <dx-data-grid
    [dataSource]="access"
    [showBorders]="true"
    [rowAlternationEnabled]="true"
    [columnAutoWidth]="true"
    noDataText="{{ 'Keine eigenen Zugangsdaten hinterlegt – es werden die Zugangsdaten von nextPIM verwendet' | translate }}"
    keyExpr="id"
  >
    <dxo-paging [enabled]="false"></dxo-paging>

    <dxi-column dataField="providerId" caption="{{ 'Anbieter' | translate }}" [width]="180">
      <dxo-lookup [dataSource]="selectableProviders" displayExpr="name" valueExpr="id"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="baseUrl" caption="{{ 'URL' | translate }}" cellTemplate="urlTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'urlTemplate'">
      <span *ngIf="cell.value">{{ cell.value }}</span>
      <span *ngIf="!cell.value" class="llm-muted">{{ 'Standard-URL des Anbieters' | translate }}</span>
    </div>

    <dxi-column dataField="token" caption="{{ 'Token' | translate }}" [width]="150" cellTemplate="tokenTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'tokenTemplate'">
      <span class="llm-token">{{ mask(cell.value) }}</span>
    </div>

    <dxi-column dataField="isDefault" caption="{{ 'Standard' | translate }}" [width]="110" cellTemplate="defaultTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'defaultTemplate'">
      <span class="llm-badge" *ngIf="cell.value">{{ 'Standard' | translate }}</span>
    </div>

    <dxi-column type="buttons" [width]="130" [visible]="isManager">
      <dxi-button hint="{{ 'Bearbeiten' | translate }}" icon="edit" [onClick]="onEdit"></dxi-button>
      <dxi-button hint="{{ 'Verbindung testen' | translate }}" icon="check" [onClick]="onTest"></dxi-button>
      <dxi-button hint="{{ 'Löschen' | translate }}" icon="trash" [onClick]="onDelete"></dxi-button>
    </dxi-column>
  </dx-data-grid>

  <div class="llm-testresult" *ngIf="testResult">
    <span [class.llm-testresult--ok]="testResult.success" [class.llm-testresult--fail]="!testResult.success">
      {{ testResult.success ? ('Verbindung erfolgreich' | translate) : testResult.error }}
    </span>
    <span class="llm-panel__hint" *ngIf="testResult.success && testResult.models.length">
      {{ testResult.models.length }} {{ 'Modelle verfügbar' | translate }}: {{ testResult.models.join(', ') }}
    </span>
    <span class="llm-panel__hint" *ngIf="testResult.note">{{ testResult.note }}</span>
  </div>
</div>

<dx-popup
  [(visible)]="editorVisible"
  [width]="620"
  [height]="'auto'"
  [showTitle]="true"
  title="{{ 'Eigene KI-Zugangsdaten' | translate }}"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'content'">
    <dx-form [(formData)]="editing" labelLocation="top" *ngIf="editing">
      <dxi-item dataField="providerId" editorType="dxSelectBox"
                [editorOptions]="{ items: selectableProviders, displayExpr: 'name', valueExpr: 'id' }">
        <dxo-label text="{{ 'Anbieter' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="baseUrl"
                [helpText]="'Leer lassen, um die Standard-URL des Anbieters zu verwenden' | translate">
        <dxo-label text="{{ 'URL' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="token" [editorOptions]="{ mode: 'password' }" [helpText]="tokenHelpText">
        <dxo-label text="{{ 'Token' | translate }}"></dxo-label>
      </dxi-item>
      <dxi-item dataField="isDefault" editorType="dxSwitch"
                [helpText]="'Wird verwendet, wenn ein Prompt keinen Anbieter vorgibt' | translate">
        <dxo-label text="{{ 'Als Standard verwenden' | translate }}"></dxo-label>
      </dxi-item>
    </dx-form>

    <div class="llm-editor__error" *ngIf="saveError">{{ saveError }}</div>

    <div class="llm-editor__actions">
      <dx-button stylingMode="text" text="{{ 'Abbrechen' | translate }}" (onClick)="editorVisible = false"></dx-button>
      <dx-button
        stylingMode="contained"
        type="default"
        text="{{ 'Speichern' | translate }}"
        [disabled]="saving"
        (onClick)="onSave()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
